import anime from '@/assets/libs/anime';

export function rangeInit(el) {
  const ctx = el;
  const content = ctx.querySelector('.range__val');
  const line = ctx.querySelector('.range__input');

  anime.set(content, { opacity: 0, translateY: '100%' });
  anime.set(line, { scaleX: 0 });
}

export function rangeAnim(el, delay = 0) {
  const ctx = el;
  const container = el.querySelector('.app__range');
  container.setAttribute('data-animated', '');
  const content = ctx.querySelector('.range__val');
  const line = ctx.querySelector('.range__input');
  const tl = anime.timeline({
    easing: 'cubicBezier(.5,0,0,1)',
    duration: 1800,
    delay,
  });

  tl
    .add({
      targets: line,
      scaleX: 1,
    }, 0)
    .add({
      targets: content,
      opacity: 1,
      translateY: 0,
    }, 800);

  tl.finished.then(() => { container.setAttribute('data-hover', ''); });

  return tl;
}

export function rangeOut(el, delay = 0) {
  const ctx = el;
  const container = el.querySelector('.app__range');
  container.removeAttribute('data-animated');
  container.removeAttribute('data-hover');
  const content = ctx.querySelector('.range__val');
  const line = ctx.querySelector('.range__input');
  const calc = (content.getBoundingClientRect().width / 2) * (((line.value / 10) - 5) / 5);
  const tl = anime.timeline({
    easing: 'cubicBezier(.5,0,0,1)',
    duration: 1200,
    delay,
  });

  tl
    .add({
      targets: content,
      opacity: 0,
      translateY: '100%',
    }, 0)
    .add({
      targets: line,
      scaleX: 0,
      transformOrigin: [`calc(${line.value}% - ${calc}px) 50% 0`, `calc(${line.value}% - ${calc}px) 50% 0`],
    }, 0);

  return tl;
}
